import React from 'react';
import styled from 'styled-components';

export interface IIcon {
  size?: string;
}

export const Icon = styled.svg.attrs<IIcon>((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  size: props.size || '1em',
  'aria-hidden': true,
}))`
  display: block;
  width: ${({ size }: IIcon) => size};
  height: ${({ size }: IIcon) => size};
  fill: currentColor;
`;

export const IconAlignLeft = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M16 6c0 .6-.4 1-1 1H4V5h11c.6 0 1 .4 1 1zm-5 3H4v2h7c.6 0 1-.4 1-1s-.4-1-1-1zM0 15h2V1H0v14z" />
  </Icon>
);

export const IconAlignCenter = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15 5H9V1H7v4H0v2h7v2H3v2h4v4h2v-4h3c.6 0 1-.4 1-1s-.4-1-1-1H9V7h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
  </Icon>
);

export const IconAlignRight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M1 5h11v2H1c-.6 0-1-.4-1-1s.4-1 1-1zm3 5c0 .6.4 1 1 1h7V9H5c-.6 0-1 .4-1 1zm10-9v14h2V1h-2z" />
  </Icon>
);

export const IconArrowElbowDownRight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M13.4 10.4 10 13.7l-.7-.7 2.5-2.5H4c-.3 0-.5-.2-.5-.5V2.5h1v7h7.3L9.3 7l.7-.7 3.4 3.4c.1.1.1.5 0 .7z" />
  </Icon>
);

export const IconBook = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M4.5 0c-1.7 0-3 1.3-3 3v10c0 1.7 1.3 3 3 3h10V0h-10zm8 14h-8c-.6 0-1-.4-1-1s.4-1 1-1h8v2zm-8-4c-.4 0-.7.1-1 .2V3c0-.6.4-1 1-1h8v8h-8z" />
  </Icon>
);

export const IconCalculation = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m14.546 4.111.707.707 1.202 1.202 1.202-1.202.707-.707 1.414 1.414-.707.707-1.202 1.202 1.202 1.202.707.707-1.414 1.415-.707-.707-1.202-1.202-1.202 1.202-.707.707-1.415-1.415.707-.707 1.202-1.202-1.202-1.202-.707-.707 1.415-1.414ZM4 6.434h7.09v2H4v-2Zm4.545 6.364v2.546h2.546v2H8.545v2.545h-2v-2.546H4v-2h2.545v-2.545h2Zm4.364 1.034H20v2h-7.09v-2Zm1 3h-1v2H20v-2h-6.09Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconCancel = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M17.707 7.707 18.414 7 17 5.586l-.707.707L12 10.586 7.707 6.293 7 5.586 5.586 7l.707.707L10.586 12l-4.293 4.293-.707.707L7 18.414l.707-.707L12 13.414l4.293 4.293.707.707L18.414 17l-.707-.707L13.414 12l4.293-4.293Z" />
  </Icon>
);

export const IconCancelSmall = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M11.707 5.707 12.414 5 11 3.586l-.707.707L8 6.586 5.707 4.293 5 3.586 3.586 5l.707.707L6.586 8l-2.293 2.293-.707.707L5 12.414l.707-.707L8 9.414l2.293 2.293.707.707L12.414 11l-.707-.707L9.414 8l2.293-2.293Z" />
  </Icon>
);

export const IconCampaign = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m23.8 11.4-1.4-1.8V5.4c0-1-.8-1.9-1.9-1.9h-6.1l-1.8-1.4c-.4-.3-.8-.3-1.1 0L9.6 3.5H3.5c-1 0-1.9.8-1.9 1.9v4.2L.2 11.4c-.3.4-.3.8 0 1.1l1.4 1.8v4.2c0 1 .8 1.9 1.9 1.9h6.1l1.8 1.4c.2.1.4.2.6.2.2 0 .4-.1.6-.2l1.8-1.4h6.1c1 0 1.9-.8 1.9-1.9v-4.2l1.4-1.8c.3-.2.3-.8 0-1.1zm-2.9 1.8c-.2.3-.4.7-.4 1.1v4.2h-6.1c-.5 0-.8.2-1.1.4l-1.1.9-1.3-.8c-.4-.2-.8-.4-1.2-.4H3.5v-4.2c0-.5-.2-.8-.4-1.1l-.9-1.1.9-1.2c.2-.5.4-.8.4-1.3V5.4h6.1c.5 0 .8-.2 1.1-.4l1.3-.9 1.2.9c.3.2.7.4 1.1.4h6.1v4.2c0 .5.2.8.4 1.1l.9 1.2-.8 1.3zM8.2 8.7c0 .8-.7 1.4-1.4 1.4s-1.4-.6-1.4-1.4.7-1.4 1.4-1.4 1.4.7 1.4 1.4zm4.7 0c0 .8-.7 1.4-1.4 1.4-.8 0-1.4-.7-1.4-1.4s.7-1.4 1.4-1.4c.8 0 1.4.7 1.4 1.4z" />
  </Icon>
);

export const IconCar = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8 4.996h-.004a1.571 1.571 0 0 0-1.423.918L4.376 9.996H3v2h1v6.25c0 .401.126.819.395 1.155.274.343.7.595 1.205.595h1.8c.506 0 .931-.252 1.205-.595.27-.336.395-.754.395-1.155v-1.25h6v1.25c0 .401.126.819.395 1.155.274.343.7.595 1.205.595h1.8c.506 0 .931-.252 1.205-.595.27-.336.395-.754.395-1.155v-6.25h1v-2h-1.376l-1.997-4.082a1.572 1.572 0 0 0-1.423-.918H7.8Zm9.597 5-1.467-3H8.07l-1.467 3h10.794ZM6 11.996v3h12v-3H6Zm11 5v1h1v-1h-1Zm-10 0H6v1h1v-1Zm1-4.5a1 1 0 0 0 0 2h1.143a1 1 0 1 0 0-2H8Zm6 1a1 1 0 0 1 1-1h1.143a1 1 0 0 1 0 2H15a1 1 0 0 1-1-1Z"
    />
  </Icon>
);

export const IconCart = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M17.2 16.2H7.4l-.3-1.8h10.6c.6 0 1.1-.2 1.6-.6.5-.4.8-.9.9-1.5L21.3 6c.1-.3 0-.6-.2-.8-.3-.1-.6-.2-.9-.2H5.3l-.4-2.3c-.1-.4-.3-.8-.6-1-.3-.3-.7-.4-1.1-.5H1.5c-.6 0-1 .4-1 1s.4 1 1 1H3L5.5 17c-.5.5-.9 1.2-.9 2.1 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9c0-.3-.1-.6-.2-.9h4.3c-.1.3-.2.6-.2.9 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9zM19.1 7l-.9 5.1c0 .1-.1.2-.2.3-.1.1-.2.1-.3.1h-11L5.7 7h13.4zM8.4 19.1c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9zm8.8.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9z" />
  </Icon>
);

export const IconChat = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M18.9 3H5.1C3.9 3 3 3.9 3 5.1v9.6c0 1.1.9 2.1 2.1 2.1h2.2V20c0 .4.2.7.6.9.1.1.2.1.4.1s.5-.1.7-.2l4.7-4H19c1.1 0 2.1-.9 2.1-2.1V5.1C21 3.9 20.1 3 18.9 3zm0 11.7h-5.7c-.2 0-.5.1-.7.2l-3.3 2.9v-2.1c0-.6-.4-1-1-1L5 14.6 5.1 5H19v.1l-.1 9.6z" />
  </Icon>
);

export const IconCheck = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m19.414 8-8.707 8.707a1 1 0 0 1-1.414 0L4.586 12 6 10.586l4 4 8-8L19.414 8Z" />
  </Icon>
);

export const IconCheckSmall = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m12.414 6-4.707 4.707a1 1 0 0 1-1.414 0L3.586 8 5 6.586l2 2 4-4L12.414 6Z" />
  </Icon>
);

export const IconChevronUp = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M16 11.4l-1.3 1.4L8 5.9l-6.7 6.9L0 11.4l6.7-6.9L8 3.2l1.3 1.4 6.7 6.8z" />
  </Icon>
);

export const IconChevronDown = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M0 4.6l1.3-1.4L8 10.1l6.7-6.9L16 4.6l-6.7 6.9L8 12.8l-1.3-1.4L0 4.6z" />
  </Icon>
);

export const IconChevronLeft = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M11.4 0l1.4 1.3L5.9 8l6.9 6.7-1.4 1.3-6.9-6.7L3.2 8l1.4-1.3L11.4 0z" />
  </Icon>
);

export const IconChevronRight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M4.6 16l-1.4-1.3L10.1 8 3.2 1.3 4.6 0l6.9 6.7L12.8 8l-1.4 1.3L4.6 16z" />
  </Icon>
);

export const IconClock = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M5 12a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm1 4.555v-1h-2v5.444a1 1 0 0 0 1 1h5.444v-2H13V7.555Z" />
  </Icon>
);

export const IconClose = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m13.4 12 3 3-1.4 1.4-3-3-3 3L7.6 15l3-3-3-3L9 7.6l3 3 3-3L16.4 9l-3 3z" />
  </Icon>
);

export const IconCopy = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M10 4H2C.9 4 0 4.9 0 6v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 10H2V6h8v8zm6-12v8c0 1.1-.9 2-2 2V2H4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2z" />
  </Icon>
);

export const IconCursorPointer = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M12.4 5.7l-4.7-.9V2.1c0-1-.7-1.9-1.6-2.1-.6-.1-1.2.1-1.6.5-.4.4-.7.9-.7 1.5v4.7h-.6c-1.1 0-1.9.9-1.9 2v1.9c0 1.1.3 2.1 1 2.9L4.1 16h9.2l1.1-7.3c.3-1.4-.6-2.8-2-3zm-.1 9H4.8l-1.5-2c-.5-.6-.7-1.3-.7-2.1V8.7c-.1-.4.2-.7.6-.7h.6v2h1.3V2c0-.2.1-.4.3-.5.1-.1.3-.1.5-.1.3.1.5.4.5.7v3.8L12.1 7c.7.2 1.2.9 1.1 1.5l-.9 6.2zM7 8.7h1.3v4.7H7V8.7zm2.6 0h1.3v4.7H9.6V8.7z" />
  </Icon>
);

export const IconDepartments = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 3a3.5 3.5 0 0 0-2.62 5.82 5.801 5.801 0 0 0-1.698 1.605l-.575.818 1.636 1.15.575-.818a3.79 3.79 0 0 1 1.306-1.165A3.45 3.45 0 0 1 8.25 10c.561 0 1.118.14 1.626.41a3.77 3.77 0 0 1 1.306 1.165 1 1 0 0 0 1.636 0 3.79 3.79 0 0 1 1.306-1.165A3.45 3.45 0 0 1 15.75 10c.561 0 1.118.14 1.626.41a3.77 3.77 0 0 1 1.306 1.165l.575.818 1.636-1.15-.575-.818a5.8 5.8 0 0 0-1.697-1.605 3.5 3.5 0 1 0-5.401-.194 5.675 5.675 0 0 0-1.22.862 5.68 5.68 0 0 0-1.183-.842l-.037-.02A3.5 3.5 0 0 0 8 3ZM6.5 15.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 12a3.5 3.5 0 0 0-2.62 5.82 5.8 5.8 0 0 0-1.698 1.605l-.575.818 1.636 1.15.575-.818a3.78 3.78 0 0 1 1.306-1.165A3.45 3.45 0 0 1 8.25 19c.561 0 1.118.14 1.626.41a3.77 3.77 0 0 1 1.306 1.165 1 1 0 0 0 1.636 0 3.78 3.78 0 0 1 1.306-1.165A3.45 3.45 0 0 1 15.75 19c.561 0 1.118.14 1.626.41a3.77 3.77 0 0 1 1.306 1.165l.575.818 1.636-1.15-.575-.818a5.8 5.8 0 0 0-1.697-1.605 3.5 3.5 0 1 0-5.401-.194l-.037.02a5.653 5.653 0 0 0-1.183.842 5.678 5.678 0 0 0-1.183-.843l-.037-.019A3.5 3.5 0 0 0 8 12Zm6.5 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
    />
  </Icon>
);

export const IconDislike = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M.1 8.8c.1.4.3.8.6 1.1.3.3.6.6 1 .7.4.2.8.3 1.2.3H6v2.2c0 .8.3 1.5.8 2.1.5.5 1.3.9 2 .9h.6c.4 0 .8-.3 1-.7L12.8 8H15c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1H3.6c-.7 0-1.4.3-1.9.7-.5.5-.9 1.1-1 1.8L0 7.6c0 .4 0 .8.1 1.2zM14 6h-1V2h1v4zM2.7 2.8c0-.2.1-.4.3-.6.2-.1.4-.2.6-.2H11v5.2L8.8 14c-.2 0-.4-.1-.5-.3-.2-.1-.3-.4-.3-.6V9.9c0-.6-.4-1-1-1H2.9c-.1 0-.2 0-.4-.1-.1 0-.2-.1-.3-.2-.1-.1-.1-.2-.2-.3v-.4l.7-5.1z" />
  </Icon>
);

export const IconDirDown = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M12 15 7 9h10l-5 6Z" />
  </Icon>
);

export const IconDirLeft = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m9 12 6-5v10l-6-5Z" />
  </Icon>
);

export const IconDirRight = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m15 12-6 5V7l6 5Z" />
  </Icon>
);

export const IconDirUp = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m12 9 5 6H7l5-6Z" />
  </Icon>
);

export const IconDocument = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8.444a1 1 0 0 0-.287-.701l-4.375-4.445A1 1 0 0 0 14.625 3H5Zm8 2H6v14h12v-9h-4a1 1 0 0 1-1-1V5Zm4.16 3H15V5.806L17.16 8ZM9 11h6v2H9v-2Zm1 4H9v2h6v-2h-5Z"
    />
  </Icon>
);

export const IconDot = (props: IIcon) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </Icon>
);

export const IconDownload = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m11.3 15-4.6-4.6L8.1 9l2.9 2.9V3h2v8.8l2.9-2.9 1.4 1.4-4.6 4.7c-.2.2-.5.3-.7.3s-.5-.1-.7-.3zm7.9-1.8v6H4.8v-6h-2v6.2c0 .5.2.9.5 1.2.3.3.8.5 1.2.5h15c.5 0 .9-.2 1.2-.5.3-.3.5-.8.5-1.2v-6.2h-2z" />
  </Icon>
);

export const IconDragAndDropHandle = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.75 6.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm6.75 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm-7.875 6.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM16.5 12a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm-7.875 6.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm7.875-1.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconDuplicate = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M14 4H2C.9 4 0 4.9 0 6v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 10H2V6h12v8zm0-12H2V0h12v2z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconExport = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M8 12.9 2.3 7.2l1.4-1.4L7 9.1V1c0-.6.4-1 1-1s1 .4 1 1v8.1l3.3-3.3 1.4 1.4L8 12.9zM0 14v2h16v-2H0z" />
  </Icon>
);

export const IconExportFilter = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M15 4h-1v2h2.595l-3.018 3.018-.707.707 1.414 1.414.707-.707L18 7.423V10h2V5a1 1 0 0 0-1-1h-4ZM4 9h7v2H4V9Zm2 4h10v2H6v-2Zm3 4H8v2h6v-2H9Z" />
  </Icon>
);

export const IconExclamationCircle = (props: IIcon) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path
      d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.5-11.5v5h-1v-5h1ZM11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconEmail = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M13.6 2.4a8 8 0 0 0-9-1.6A7.8 7.8 0 0 0 1.8 3 8 8 0 0 0 .2 6.1a8 8 0 0 0 1.4 6.7A8 8 0 0 0 7.7 16a8 8 0 0 0 3.5-.7l1-.4-.9-1.8-1 .4A6 6 0 1 1 14 8v1a1 1 0 1 1-2 0V8a4 4 0 0 0-.9-2.5 4 4 0 0 0-6.8.8 4 4 0 0 0 1.3 5 4 4 0 0 0 5.1-.4 3.1 3.1 0 0 0 1.5 1 3 3 0 0 0 1.8 0A3 3 0 0 0 16 9V8a8 8 0 0 0-2.4-5.7Zm-4.2 7A2 2 0 0 1 8 10a2 2 0 1 1 2-2 2 2 0 0 1-.6 1.4Z" />
  </Icon>
);

export const IconEnlarge = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15 1v8h-2V3.4L3.4 13H9v2H1a1 1 0 0 1-.4 0 1 1 0 0 1-.5-.6A1 1 0 0 1 0 14V6h2v5.6L11.6 2H6V0h8a1 1 0 0 1 .4 0 1 1 0 0 1 .5.6 1 1 0 0 1 .1.4Z" />
  </Icon>
);

export const IconExclamation = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M13 6.5v-1h-2v9h2v-8Zm.125 10.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z" />
  </Icon>
);

export const IconFactory = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M8,15h3v2H8V15z M13,15v2h3v-2H13z M21,19v2H3v-2h1V9c0-0.4,0.2-0.8,0.6-0.9C4.9,7.9,5.4,8,5.7,8.3l2.8,2.5V9 c0-0.4,0.2-0.8,0.6-0.9C9.4,7.9,9.9,8,10.2,8.3l3.2,2.8l1.2-6.3C14.6,4.3,15,4,15.5,4h2c0.5,0,0.9,0.3,1,0.8l1.5,8 c0,0.1,0,0.1,0,0.2v6H21z M15.2,12h2.6l-1.1-6h-0.3L15.2,12z M6,19h12v-5h-4v0c-0.2,0-0.5-0.1-0.7-0.2l-2.8-2.5V13 c0,0.4-0.2,0.8-0.6,0.9c-0.4,0.2-0.8,0.1-1.1-0.2L6,11.2V19z" />
  </Icon>
);

export const IconFilter = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M12 12c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1zm1-5H3c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1zm2-4H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z" />
  </Icon>
);

export const IconFlash = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M12.907 4.04a1 1 0 0 1 .718.96v4.25H17a1 1 0 0 1 .841 1.54l-5.625 8.75a1 1 0 0 1-1.841-.54v-4.25H7a1 1 0 0 1-.841-1.54l5.625-8.75a1 1 0 0 1 1.123-.42Zm-4.075 8.71h2.543a1 1 0 0 1 1 1v1.845l2.793-4.345h-2.543a1 1 0 0 1-1-1V8.405L8.832 12.75Z" />
  </Icon>
);

export const IconForm = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10.215 5.7A2.59 2.59 0 0 1 12 5c.678 0 1.32.257 1.785.7.378.36.614.817.69 1.3h-4.95c.076-.483.312-.94.69-1.3ZM7.718 6H6v13h12V6h-1.718c.143.426.218.875.218 1.333V8a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-.667c0-.458.075-.907.218-1.333Zm7.158-2A4.608 4.608 0 0 0 12 3a4.607 4.607 0 0 0-2.876 1H5.7c-.429 0-.853.158-1.177.46A1.63 1.63 0 0 0 4 5.651v13.696c0 .462.198.89.523 1.193.324.3.748.459 1.177.459h12.6c.429 0 .853-.158 1.177-.46a1.63 1.63 0 0 0 .523-1.19V5.652c0-.462-.198-.89-.523-1.193A1.727 1.727 0 0 0 18.3 4h-3.424ZM9.5 11h-1v2h7v-2h-6Zm0 4h-1v2h7v-2h-6Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconHeight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M4.7 0v16h6.7V0H4.7zM10 14.7H6v-2h2v-1.3H6V10h2.7V8.7H6V7.3h2V6H6V4.7h2.7V3.3H6v-2h4v13.4z" />
  </Icon>
);

export const IconIframe = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.521 7.693.693-.722L8.77 5.586l-.692.721-4.8 5a1 1 0 0 0 0 1.386l4.8 5 .692.72 1.443-1.384-.693-.721L5.386 12l4.135-4.307Zm6.4-1.386-.692-.72-1.443 1.384.693.722L18.614 12l-4.135 4.308-.693.72 1.443 1.386.692-.722 4.8-5a1 1 0 0 0 0-1.385l-4.8-5Z"
    />
  </Icon>
);

export const IconImage = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6v7.81l.99-1.077c.147-.162.327-.295.532-.388a1.592 1.592 0 0 1 1.851.388l1.354 1.473 3.263-3.55a1.65 1.65 0 0 1 .532-.387 1.592 1.592 0 0 1 1.851.388L18 12.426V6H6ZM4 16.371v1.993C4 19.267 4.733 20 5.636 20h12.728c.903 0 1.636-.733 1.636-1.636V5.637C20 4.732 19.267 4 18.364 4H5.636C4.733 4 4 4.733 4 5.636v10.735ZM18 18v-2.62l-2.818-3.064-3.263 3.548a1.636 1.636 0 0 1-.532.389 1.594 1.594 0 0 1-1.851-.389l-1.354-1.472L6 16.765V18h12Zm-6.875-9.063a1.312 1.312 0 1 1-2.625 0 1.312 1.312 0 0 1 2.625 0Z"
    />
  </Icon>
);

export const IconImport = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.282 18.98a1 1 0 0 1-1 1h-4.556v-2h3.556V5.758H6.06v3.556h-2V4.758a1 1 0 0 1 1-1h14.222a1 1 0 0 1 1 1V18.98Zm-15.01-7.95h6.657a1 1 0 0 1 1 1v6.658h-2v-4.243l-5.09 5.09-.707.707-1.414-1.414.707-.707 5.09-5.09H5.272v-2Z"
    />
  </Icon>
);

export const IconInfo = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M10.3 12.3v2H8c-.6 0-1-.4-1-1v-5H5.7v-2H8c.6 0 1 .4 1 1v5h1.3zM8 5c.6 0 1-.4 1-1v-.3c0-.6-.4-1-1-1s-1 .4-1 1V4c0 .6.4 1 1 1z" />
  </Icon>
);

export const IconInfoCircle = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <>
      <circle cx="8" cy="8" r="7" stroke="currentColor" fill="transparent" strokeWidth="2" />
      <path
        d="M7 7.5H8V11.5H9"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.9375 4.5C8.9375 5.01777 8.51777 5.4375 8 5.4375C7.48223 5.4375 7.0625 5.01777 7.0625 4.5C7.0625 3.98223 7.48223 3.5625 8 3.5625C8.51777 3.5625 8.9375 3.98223 8.9375 4.5Z"
        stroke="currentcolor"
        strokeWidth="0.125"
      />
    </>
  </Icon>
);

export const IconFinn = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M8.44446 4.44445C8.44446 4.32172 8.54395 4.22223 8.66668 4.22223H15.7778C15.9005 4.22223 16 4.32172 16 4.44445V11.5556C16 11.6783 15.9005 11.7778 15.7778 11.7778H8.44446V4.44445Z"
      fill="currentcolor"
    />
    <path
      d="M0 4.44445C0 4.32172 0.0994923 4.22223 0.222222 4.22223H2.66667C5.36673 4.22223 7.55556 6.41106 7.55556 9.11112V11.7778H0.222223C0.0994926 11.7778 0 11.6783 0 11.5556V4.44445Z"
      fill="currentcolor"
    />
  </Icon>
);

export const IconInputCheckbox = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 18V6h12v12H6ZM4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5Zm11.707 5.707.707-.707L15 8.586l-.707.707L11 12.586l-1.293-1.293L9 10.586 7.586 12l.707.707 2 2a1 1 0 0 0 1.414 0l4-4Z"
    />
  </Icon>
);

export const IconInputRadio = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
  </Icon>
);

export const IconInputSelect = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 15V9h16v6H4ZM2 8a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8Zm7.5 2.5 2.5 3 2.5-3h-5Z"
    />
  </Icon>
);

export const IconInputText = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M4 9H3v2h18V9H4Zm0 4H3v2h14v-2H4Z" />
  </Icon>
);

export const IconInputTextarea = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 5H3v2h18V5H4Zm0 4H3v2h14V9H4Zm-1 4h18v2H3v-2Zm1 4H3v2h14v-2H4Z"
    />
  </Icon>
);

export const IconKebab = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M14 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </Icon>
);

export const IconLike = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15.9 7.2c-.1-.4-.3-.8-.6-1.1-.3-.3-.6-.6-1-.7-.4-.2-.8-.3-1.2-.3H10V2.9c0-.8-.3-1.5-.8-2.1C8.6.3 7.9 0 7.1 0h-.6c-.4 0-.8.3-1 .7L3.2 8H1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h11.4c.7 0 1.4-.3 1.9-.7.5-.5.9-1.1 1-1.8l.7-5.1c0-.4 0-.8-.1-1.2zM2 10h1v4H2v-4zm11.3 3.2c0 .2-.1.4-.3.6-.2.1-.4.2-.6.2H5V8.8L7.2 2c.2 0 .4.1.5.3.2.1.3.4.3.6v3.2c0 .6.4 1 1 1h4.1c.1 0 .2 0 .4.1.1.1.2.1.3.2.1.1.1.2.2.3v.4l-.7 5.1z" />
  </Icon>
);

export const IconLink = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.694 7.72 1.112-1.073a2.512 2.512 0 0 1 3.553 3.54l-2.235 2.227-.002.003a2.495 2.495 0 0 1-3.536 0l-.706-.708-1.417 1.411.706.709a4.496 4.496 0 0 0 6.368 0h.002l2.25-2.243a4.512 4.512 0 0 0-6.361-6.389L11.305 6.28l-.719.694 1.389 1.439.72-.694ZM9.69 11.04a2.496 2.496 0 0 1 2.725.543l.706.708 1.417-1.411-.706-.709a4.495 4.495 0 0 0-6.368 0L5.21 12.413a4.512 4.512 0 0 0 6.361 6.389l1.123-1.084.72-.694-1.389-1.439-.72.694-1.111 1.073a2.512 2.512 0 0 1-3.553-3.54l2.235-2.227.002-.003c.232-.233.508-.417.811-.543Z"
    />
  </Icon>
);

export const IconList = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5H9v2h11V5H10Zm0 6H9v2h11v-2H10Zm-1 6h11v2H9v-2Zm-4-6a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H5ZM4 6a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1Zm1 11a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H5Z"
    />
  </Icon>
);

export const IconLocationPin = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M9.444 8.059a3.616 3.616 0 0 1 6.171 2.556c0 1.717-.965 3.333-2.062 4.594A14.005 14.005 0 0 1 12 16.73l-.073-.062a14.015 14.015 0 0 1-1.48-1.459c-1.097-1.26-2.062-2.877-2.062-4.594 0-.958.38-1.878 1.059-2.556Zm1.982 10.76L12 18l-.573.82a1 1 0 0 0 1.146 0L12 18c.573.82.574.819.574.819l.002-.002.005-.003.014-.01a5.473 5.473 0 0 0 .21-.156 15.995 15.995 0 0 0 2.257-2.126c1.211-1.393 2.553-3.47 2.553-5.907a5.615 5.615 0 1 0-11.23 0c0 2.437 1.342 4.514 2.553 5.907a16.01 16.01 0 0 0 2.256 2.126 9.526 9.526 0 0 0 .211.156l.014.01.005.003.001.001h.001ZM13.5 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
  </Icon>
);

export const IconLocationPinSmall = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M5.444 4.059a3.615 3.615 0 0 1 6.171 2.556c0 1.717-.965 3.333-2.062 4.594A14.01 14.01 0 0 1 8 12.73l-.073-.062a14.01 14.01 0 0 1-1.48-1.459C5.35 9.95 4.385 8.332 4.385 6.615c0-.958.38-1.878 1.059-2.556Zm1.982 10.76L8 14l-.573.82a1 1 0 0 0 1.146 0L8 14c.573.82.574.819.574.819l.002-.002.005-.003.014-.01.046-.034a14.05 14.05 0 0 0 .727-.578 16 16 0 0 0 1.694-1.67c1.211-1.393 2.553-3.47 2.553-5.907a5.615 5.615 0 1 0-11.23 0c0 2.437 1.342 4.514 2.553 5.907a16.006 16.006 0 0 0 2.256 2.126 9.6 9.6 0 0 0 .211.156l.014.01.005.003.001.001h.001ZM9.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
  </Icon>
);

export const IconLock = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 9v1.5h-3V9a1.5 1.5 0 0 1 3 0Zm-5 1.5V9a3.5 3.5 0 1 1 7 0v1.5h.5a2 2 0 0 1 2 2v6H6v-6a2 2 0 0 1 2-2h.5Zm7 2H8v4h8v-4h-.5Z"
    />
  </Icon>
);

export const IconMap = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15.6.7c-.2-.2-.5-.2-.8-.1L10.4 2 6 .1C5.8 0 5.6 0 5.4 0L.6 1.6c-.4.1-.6.4-.6.8v12.2c0 .3.1.6.4.7.2.2.5.2.8.1L5.6 14l4.4 1.9c.1 0 .2.1.3.1h.3l4.7-1.5c.4-.1.6-.5.6-.8V1.4c.1-.3 0-.6-.3-.7zM6.2 2.1l3.6 1.5v10.3l-3.6-1.5V2.1zm-4.4 1l2.7-.9v10.3l-2.7.9V3.1zm12.4 9.8l-2.7.9V3.5l2.7-.9v10.3z" />
  </Icon>
);

export const IconMeatballs = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm5-2a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm7 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z" />
  </Icon>
);

export const IconMeatballsSmall = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm4.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
  </Icon>
);

export const IconMinus = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M17.2 11v2H6.8v-2h10.4z" />
  </Icon>
);

export const IconPerson = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 10.601a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-5a5 5 0 0 0-3.256 8.795 6.799 6.799 0 0 0-2.352 2.016l-.59.807 1.616 1.18.59-.808a4.805 4.805 0 0 1 1.735-1.46 5.05 5.05 0 0 1 2.257-.53 5.05 5.05 0 0 1 2.257.53c.696.348 1.29.85 1.735 1.46l.59.808 1.615-1.18-.59-.807a6.799 6.799 0 0 0-2.351-2.016A5 5 0 0 0 12 5.601Z"
    />
  </Icon>
);

export const IconPhone = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M21.7 15.4c-.2-.3-.5-.6-.8-.7l-4.4-1.9c-.3-.1-.6-.2-.9-.1-.3 0-.6.1-.8.3l-2.2 1.5c-1.3-.7-2.3-1.7-3-3l1.5-2.3c.2-.2.2-.5.3-.8 0-.3 0-.6-.1-.8L9.4 3.1c-.2-.3-.4-.6-.8-.8-.3-.2-.7-.3-1-.3-1.4.2-2.6.9-3.5 1.9-.9 1-1.4 2.3-1.4 3.6 0 3.7 1.4 7.1 4 9.7 2.6 2.6 6.1 4 9.7 4 1.3 0 2.6-.5 3.6-1.4 1-.9 1.7-2.1 1.8-3.4.2-.3.1-.7-.1-1zm-2.9 3c-.6.6-1.5.9-2.3.9-3.1 0-6.1-1.2-8.3-3.4-2.2-2.3-3.4-5.3-3.4-8.4 0-.9.3-1.7.9-2.3.5-.6 1.2-1 2-1.1l1.8 4.1L8 10.5c-.2.3-.3.5-.3.8 0 .3 0 .6.2.9.9 1.8 2.3 3.2 4.1 4.1.3.1.6.2.9.2.3 0 .6-.1.8-.3l2.2-1.5 4.1 1.8c-.2.7-.6 1.4-1.2 1.9z" />
  </Icon>
);

export const IconPlus = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M17.2 13H13v4.2h-2V13H6.8v-2H11V6.8h2V11h4.2v2z" />
  </Icon>
);

export const IconProcess = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M12.965 4.078c.33.047.66.113.984.2.036.01.073.018.109.023a8.154 8.154 0 0 1 4.727 3.5c.415.66.73 1.38.935 2.136.009.032.019.064.03.095a7.855 7.855 0 0 1-.03 4.037 7.968 7.968 0 0 1-1.285 2.642 8.164 8.164 0 0 1-4.391 2.991 1.044 1.044 0 0 0-.086.02c-.23.061-.461.113-.694.154-.461.08-.936.12-1.421.12a.968.968 0 0 0-.078.004 8.135 8.135 0 0 1-2.029-.279 1 1 0 0 0-.519 1.932c1.447.389 2.96.45 4.428.187a10.198 10.198 0 0 0 6.137-3.604A9.85 9.85 0 0 0 22 12a9.839 9.839 0 0 0-1.87-5.782 10.013 10.013 0 0 0-1.164-1.344 10.2 10.2 0 0 0-5.71-2.774 10.141 10.141 0 0 0-4.048.247 1 1 0 1 0 .519 1.931A8.135 8.135 0 0 1 11.763 4c.026.002.053.003.08.003.38 0 .755.026 1.122.075Zm-6.897 2.27a1 1 0 1 0-1.404-1.423 9.998 9.998 0 0 0-2.628 4.477 1 1 0 1 0 1.929.529 7.998 7.998 0 0 1 2.103-3.582Zm-2.103 7.715a1 1 0 1 0-1.93.522 9.932 9.932 0 0 0 2.63 4.491 1 1 0 1 0 1.402-1.426 7.932 7.932 0 0 1-2.102-3.587Zm13.488-4.266-.73.683-5.599 5.248a1 1 0 0 1-1.368 0L6.96 13.104l-.73-.685 1.37-1.458.729.685 2.111 1.982 4.915-4.607.73-.684 1.367 1.46Z" />
  </Icon>
);

export const IconRefresh = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22 3.8v5.5c0 .6-.4 1-1 1h-5.5v-2h3.1l-1.5-1.5c-1-1-2.3-1.7-3.7-2-1.4-.2-2.8 0-4.2.5C7.9 5.9 6.8 6.8 6 8c-.8 1.2-1.2 2.6-1.2 4s.4 2.8 1.2 4c.8 1.2 1.9 2.1 3.3 2.7 1.3.5 2.8.7 4.2.4 1.4-.3 2.7-1 3.7-2l.7-.7 1.4 1.4-.7.7c-1.3 1.3-2.9 2.2-4.7 2.5-.6.1-1.2.2-1.8.2-1.2 0-2.4-.2-3.5-.7-1.7-.7-3.1-1.9-4.2-3.4-1-1.5-1.6-3.3-1.6-5.1s.5-3.6 1.6-5.1c1-1.5 2.5-2.7 4.2-3.4 1.7-.7 3.5-.9 5.3-.5 1.8.4 3.4 1.2 4.7 2.5L20 6.9V3.8h2z" />
  </Icon>
);

export const IconSearch = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m22.4 21-4.6-4.6c1.2-1.5 1.9-3.4 1.9-5.5 0-4.9-4-8.9-8.9-8.9S2 6 2 10.9s4 8.9 8.9 8.9c2.1 0 4-.7 5.5-1.9l4.6 4.6 1.4-1.5zM4 10.9C4 7.1 7.1 4 10.9 4s6.9 3.1 6.9 6.9-3.1 6.9-6.9 6.9S4 14.7 4 10.9z" />
  </Icon>
);

export const IconSettings = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M11 10h2v11h-2V10zm7 11h2v-3h-2v3zm3-6h-1V3h-2v12h-1c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zM4 21h2v-6H4v6zm3-9H6V3H4v9H3c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1zm7-5h-1V3h-2v4h-1c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1z" />
  </Icon>
);

export const IconSort = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m8.295 19.33.705.706.707-.708 3.536-3.535-1.415-1.414L10 16.207v-5.586a1 1 0 1 0-2 0v5.586L6.172 14.38l-1.415 1.414 3.534 3.533.004.005ZM15 3.965l.707.708 3.536 3.535-1.415 1.414L16 7.793v5.828a1 1 0 1 1-2 0V7.793L12.172 9.62l-1.415-1.414 3.536-3.535.707-.708Z" />
  </Icon>
);

export const IconStar = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 7.228-1.323 1.93A3 3 0 0 1 9.05 10.34l-2.245.662 1.428 1.855a3 3 0 0 1 .62 1.912l-.064 2.34 2.206-.784a3 3 0 0 1 2.01 0l2.206.784-.065-2.34a3 3 0 0 1 .621-1.912l1.428-1.855-2.245-.662a3 3 0 0 1-1.627-1.181L12 7.228ZM4.84 9.496a1 1 0 0 0-.51 1.57l2.317 3.01a1 1 0 0 1 .208.638l-.105 3.799a1 1 0 0 0 1.335.97l3.58-1.274a1 1 0 0 1 .67 0l3.58 1.273a1 1 0 0 0 1.335-.97l-.105-3.798a1 1 0 0 1 .208-.637l2.317-3.012a1 1 0 0 0-.51-1.569l-3.645-1.074a1 1 0 0 1-.542-.394l-2.148-3.134a1 1 0 0 0-1.65 0L9.027 8.028a1 1 0 0 1-.542.394L4.84 9.496Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconStarFilled = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M11.175 4.894a1 1 0 0 1 1.65 0l2.148 3.134a1 1 0 0 0 .542.394l3.645 1.074a1 1 0 0 1 .51 1.57l-2.317 3.01a1 1 0 0 0-.208.638l.105 3.799a1 1 0 0 1-1.335.97l-3.58-1.274a1 1 0 0 0-.67 0l-3.58 1.273a1 1 0 0 1-1.335-.97l.105-3.798a1 1 0 0 0-.208-.637L4.33 11.065a1 1 0 0 1 .51-1.569l3.645-1.074a1 1 0 0 0 .542-.394l2.148-3.134Z" />
  </Icon>
);

// TODO: Fix this icon to use outline stroke and merge paths
export const IconSignature = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props} style={{ fill: 'none' }}>
    <path
      d="M4 16h16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M4 19S12.886 5 8.147 5h.007C4.628 5 4.584 19.08 12 10.264v-.014s1.23 5.674 4.308 1.194v-.027s0 1.75 3.692 1.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </Icon>
);

export const IconSphere = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M12 3c-1.743 0-3.1 1.281-3.964 2.864-.884 1.621-1.4 3.793-1.4 6.136 0 .752.054 1.486.155 2.19-1.269-.7-1.775-1.502-1.79-2.158a2.254 2.254 0 0 1 1.004-1.696 1 1 0 1 0-1.101-1.669 4.254 4.254 0 0 0-1.902 3.266L3 11.966V12c0 1.743 1.281 3.1 2.864 3.963.462.252.968.474 1.51.663a10.1 10.1 0 0 0 .662 1.51C8.9 19.719 10.257 21 12 21h.034l.033-.002a4.255 4.255 0 0 0 3.266-1.902 1 1 0 0 0-1.67-1.101A2.254 2.254 0 0 1 11.969 19c-.656-.016-1.458-.522-2.159-1.79.705.1 1.439.154 2.191.154 2.343 0 4.515-.516 6.136-1.4C19.719 15.1 21 13.742 21 12c0-1.743-1.281-3.1-2.864-3.964a10.067 10.067 0 0 0-1.51-.662 10.077 10.077 0 0 0-.662-1.51C15.1 4.281 13.743 3 12 3Zm3.016 5.984a12.84 12.84 0 0 1 .33 3.692 1 1 0 0 0 1.997.103 15.397 15.397 0 0 0-.134-2.97C18.5 10.521 19 11.338 19 12c0 .668-.51 1.492-1.822 2.208-1.274.695-3.103 1.156-5.178 1.156a12.84 12.84 0 0 1-3.016-.348A12.84 12.84 0 0 1 8.636 12c0-2.075.461-3.904 1.156-5.178C10.508 5.51 11.332 5 12 5c.662 0 1.479.502 2.19 1.79a15.397 15.397 0 0 0-2.969-.133 1 1 0 0 0 .103 1.998 12.84 12.84 0 0 1 3.692.33Z" />
  </Icon>
);

export const IconStep = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="m8.76 11.442.735-.678-1.356-1.47-.735.677-2.575 2.374-.943-.873-.735-.679-1.358 1.469.735.679 1.621 1.5a1 1 0 0 0 1.357 0l3.253-3Zm3.447-.736h-1v2h11v-2h-10Z" />
  </Icon>
);

export const IconSupportRound = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-9.178-4.744a2.841 2.841 0 0 1 1.78-.191c.6.13 1.137.45 1.55.9.412.452.684 1.015.793 1.617.11.601.054 1.225-.162 1.797a3.156 3.156 0 0 1-1.082 1.435 2.934 2.934 0 0 1-.701.379V14h-2v-1.625a1 1 0 0 1 1-1 .88.88 0 0 0 .521-.176c.164-.12.305-.3.392-.528.086-.229.11-.484.065-.731a1.259 1.259 0 0 0-.302-.625.954.954 0 0 0-.498-.296.841.841 0 0 0-.53.058 1.052 1.052 0 0 0-.458.417c-.12.198-.19.44-.19.694v1H9v-1c0-.612.165-1.216.484-1.737a3.05 3.05 0 0 1 1.338-1.195ZM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </Icon>
);

export const IconText = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4h-2V6h-5v12h3v2H8v-2h3V6H6v3H4V5Z"
    />
  </Icon>
);

export const IconTextSnippet = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M15 4H0V2h15c.6 0 1 .4 1 1s-.4 1-1 1zm0 3H0v2h15c.6 0 1-.4 1-1s-.4-1-1-1zm-4 5H0v2h11c.6 0 1-.4 1-1s-.4-1-1-1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconThreeSixty = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M12 4a1 1 0 0 1 1 1v8.3a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1ZM9.63 7.386a1 1 0 0 1-.713 1.221c-1.268.333-2.282.852-2.96 1.444-.675.59-.957 1.195-.957 1.746 0 .75.54 1.623 1.84 2.365 1.27.727 3.093 1.208 5.16 1.208s3.89-.481 5.16-1.207c1.3-.743 1.84-1.617 1.84-2.366 0-.55-.282-1.155-.957-1.746-.678-.592-1.692-1.11-2.96-1.444a1 1 0 0 1 .508-1.934c1.485.39 2.802 1.028 3.768 1.872.967.846 1.641 1.959 1.641 3.252 0 1.776-1.25 3.19-2.847 4.102-1.624.928-3.802 1.471-6.153 1.471-2.351 0-4.529-.543-6.153-1.471C4.25 14.986 3 13.574 3 11.797c0-1.293.673-2.406 1.641-3.252.966-.844 2.283-1.482 3.767-1.872a1 1 0 0 1 1.222.713ZM13 19.5a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1Z" />
  </Icon>
);

export const IconTowbar = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2a4.002 4.002 0 0 1-3 3.874V14h.5a2 2 0 0 0 1.6-.8l1.2-1.6a4 4 0 0 1 3.2-1.6H20v2h-3.5a2 2 0 0 0-1.6.8l-1.2 1.6a4 4 0 0 1-3.2 1.6H10v4H8v-4H4v-2h4v-2.126A4.002 4.002 0 0 1 9 4a4 4 0 0 1 4 4Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconTrash = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M12 3V1c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v2H0v2h1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5h1V3h-4zM6 2h4v1H6V2zm7 12H3V5h10v9zm-2-1H9V7h2v6zm-4 0H5V7h2v6z" />
  </Icon>
);

export const IconTreeStructure = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M16 8v1h2V7h-2v1Zm-2 1h-.2a.742.742 0 0 0-.542.247c-.158.17-.258.414-.258.682v5.142c0 .268.1.512.258.682A.742.742 0 0 0 13.8 16h.2v-.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V18h-.2a2.741 2.741 0 0 1-2.004-.883A3 3 0 0 1 11 15.072V13.5H9A1.5 1.5 0 0 1 7.5 15h-2A1.5 1.5 0 0 1 4 13.5v-2A1.5 1.5 0 0 1 5.5 10h2A1.5 1.5 0 0 1 9 11.5h2V9.929a3 3 0 0 1 .796-2.046A2.741 2.741 0 0 1 13.8 7h.2v-.5A1.5 1.5 0 0 1 15.5 5h3A1.5 1.5 0 0 1 20 6.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 14 9.5V9Zm2 8v1h2v-2h-2v1ZM6 12v1h1v-1H6Z" />
  </Icon>
);

export const IconTrendDown = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M13.6 5h2v7h-7v-2h3.6L8.6 6.4l-4 4-4-4C.3 6 .3 5.4.6 5s1-.4 1.4 0l2.6 2.6 4-4 5 5V5z" />
  </Icon>
);

export const IconTrendUp = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M8.6 3.6h7v7h-2V7l-5 5-4-4L2 10.6c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4-4 4 4 3.6-3.6H8.6v-2z" />
  </Icon>
);

export const IconTrendRight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m14.2 8.7-4 4-1.4-1.4L11.1 9H2.5c-.6 0-1-.4-1-1s.4-1 1-1h8.6L8.8 4.7l1.4-1.4 4 4 .7.7-.7.7z" />
  </Icon>
);

export const IconTypography = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M14 1v3.5h-1.2l-.3-1c-.2-.5-.6-.8-1.1-.8H9.2v9.6c0 .5.4 1 .9 1.1l1.5.4V15H4.4v-1.2l1.5-.4c.5-.1.9-.6.9-1.1V2.8H4.7c-.5 0-1 .3-1.1.8l-.3 1H2V1h12z" />
  </Icon>
);

export const IconUpload = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m7 3.4-4 4L1.6 6 7.3.3c.4-.4 1-.4 1.4 0L14.4 6 13 7.4l-4-4V12H7V3.4zM1 14h14v2H1v-2z" />
  </Icon>
);

export const IconValignTop = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M5 4h2v11c0 .6-.4 1-1 1s-1-.4-1-1V4zm4 7c0 .6.4 1 1 1s1-.4 1-1V4H9v7zM1 0v2h14V0H1z" />
  </Icon>
);

export const IconValignCenter = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15 9h-4v7H9V9H7v4H5V9H1V7h4V4c0-.6.4-1 1-1s1 .4 1 1v3h2V1c0-.6.4-1 1-1s1 .4 1 1v6h4v2z" />
  </Icon>
);

export const IconValignBottom = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M11 12H9V1c0-.6.4-1 1-1s1 .4 1 1v11zM7 5c0-.6-.4-1-1-1s-1 .4-1 1v7h2V5zm-6 9v2h14v-2H1z" />
  </Icon>
);

export const IconVideo = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M3 4a1 1 0 0 0-1 1v13.222c0 .46.176.908.5 1.244.325.337.774.534 1.25.534h16.5c.476 0 .925-.197 1.25-.534.324-.336.5-.784.5-1.244V5a1 1 0 0 0-1-1H3Zm1 14V6h16v12H4Zm6.514-9.857A1 1 0 0 0 9 9v6a1 1 0 0 0 1.514.857l5-3a1 1 0 0 0 0-1.714l-5-3ZM13.056 12 11 13.234v-2.468L13.056 12Z" />
  </Icon>
);

export const IconWebhook = (props: IIcon) => (
  <Icon viewBox="0 0 14.8 14.8" {...props}>
    <path d="M.4 4.4a1 1 0 0 1 1-1H11l-2-2L10.4 0l3.7 3.7.7.7-.7.7-3.7 3.7L9 7.4l2-2H1.4a1 1 0 0 1-1-1Zm13 5H3.8l2-2L4.4 6 .7 9.7l-.7.7.7.7 3.7 3.7 1.4-1.4-2-2h9.6a1 1 0 0 0 0-2Z" />
  </Icon>
);

export const IconWebsite = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 8.5C5 7.7 5.7 7 6.5 7S8 7.7 8 8.5 7.3 10 6.5 10 5 9.3 5 8.5zm5 0c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5S10 9.3 10 8.5z" />
  </Icon>
);

export const IconWidth = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M16 4.7H0v6.7h16V4.7zM1.3 10V6h2v2h1.3V6H6v2.7h1.3V6h1.4v2H10V6h1.3v2.7h1.4V6h2v4H1.3z" />
  </Icon>
);

// Module Icons

export const IconModuleAccordion = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M33 4H7C5.3 4 4 5.3 4 7v26c0 1.7 1.3 3 3 3h26c1.7 0 3-1.3 3-3V7c0-1.7-1.3-3-3-3zm1 29c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-5h28v5zm0-7H6V14h28v12zm0-14H6V7c0-.6.4-1 1-1h26c.6 0 1 .4 1 1v5zm-7-5h5l-2.5 4L27 7zm2.5 26L27 29h5l-2.5 4zM32 19h-5l2.5-4 2.5 4z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleCallToAction = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M26.8 16.5l-7.1-1.3v-4.1c0-1.5-1.1-2.8-2.4-3.1-.9-.1-1.8.1-2.3.7-.7.6-1.1 1.4-1.1 2.3v7h-1c-1.7 0-2.9 1.3-2.9 3v2.9c0 1.6.5 3.1 1.5 4.4l2.9 3.7h13.9L30 21c.3-2.1-1-4.1-3.2-4.5zm1.3 4.2L26.6 30H15.3L13 27c-.7-.9-1.1-2-1.1-3.1V21c0-.6.4-1 1-1h1v3h1.9V11c0-.3.1-.6.4-.8.2-.2.5-.2.8-.2.4.1.8.6.8 1.1v5.7l8.7 1.6c1 .3 1.7 1.3 1.6 2.3zM18 20h1.9v7H18v-7zm3.8 0h1.9v7h-1.9v-7z" />
  </Icon>
);

export const IconModuleCampaign = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M26.4 15L15 26.4 13.6 25 25 13.6l1.4 1.4zM13 16c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm2 0c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm12 8c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3zm-2 0c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1zm11.3-4L32 25.4V32h-6.6L20 36.3 14.6 32H8v-6.6L3.7 20 8 14.6V8h6.6L20 3.7 25.4 8H32v6.6l4.3 5.4zm-2.6 0L30 15.4V10h-5.4L20 6.3 15.4 10H10v5.4L6.3 20l3.7 4.6V30h5.4l4.6 3.7 4.6-3.7H30v-5.4l3.7-4.6z" />
  </Icon>
);

export const IconModuleContacts = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M15 20.5c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zm0-14c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm14 12c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm-14 12c-6.6 0-12 5.4-12 12 0 .6.4 1 1 1h22c.6 0 1-.4 1-1 0-6.6-5.4-12-12-12zm-10 11c.5-5 4.8-9 10-9s9.4 4 10 9H5zM37 29v2.5c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1s.4-1 1-1h5V29c0-3.6-2.7-6.5-6.1-6.5-1.2 0-2.3.4-3.3 1.1-.5.3-1.1.2-1.4-.2-.3-.5-.2-1.1.2-1.4 1.3-.9 2.9-1.4 4.5-1.4 4.5-.1 8.1 3.7 8.1 8.4z" />
  </Icon>
);

export const IconModuleGridList = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M12 6H8c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 6H8V8h4v4zm0 14H8c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H8v-4h4v4zm8-26c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 14c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM10 16c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM32 6h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 6h-4V8h4v4zm0 14h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6h-4v-4h4v4zM22 16h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6h-4v-4h4v4zm8-6c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </Icon>
);

export const IconModuleForm = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M31 10.7v20.6c0 1.5-1.1 2.7-2.5 2.7h-17C10.1 34 9 32.8 9 31.3V10.7C9 9.2 10.1 8 11.5 8H13v2h-1.5c-.3 0-.5.3-.5.7v20.6c0 .4.2.7.5.7h16.9c.3 0 .5-.3.5-.7V10.7c0-.4-.2-.7-.5-.7H27V8h1.5c1.4 0 2.5 1.2 2.5 2.7zM25 12H15V6h10v6zm-2-4h-6v2h6V8zm3 13H14v2h12v-2zm0-4H14v2h12v-2zm0 8H14v2h12v-2z" />
  </Icon>
);

export const IconModuleHeading = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M35 20.5c0 .6-.4 1-1 1H5v-2h29c.6 0 1 .4 1 1zm-1 4H5v2h29c.6 0 1-.4 1-1s-.4-1-1-1zm-10 5H5v2h19c.6 0 1-.4 1-1s-.4-1-1-1zm7-13H5v-8h26c1.1 0 2.1.4 2.8 1.2.8.8 1.2 1.8 1.2 2.8s-.4 2.1-1.2 2.8-1.7 1.2-2.8 1.2zm-24-2h24c.5 0 1-.2 1.4-.6s.6-.9.6-1.4-.2-1-.6-1.4c-.4-.4-.9-.6-1.4-.6H7v4z" />
  </Icon>
);

export const IconModuleHero = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M34 9H6c-2.2 0-4 1.8-4 4v14c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V13c0-2.2-1.8-4-4-4zm2 18c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V13c0-1.1.9-2 2-2h28c1.1 0 2 .9 2 2v14zm-17-6c0 .6-.4 1-1 1H7v-2h11c.6 0 1 .4 1 1zm-4 4c0 .6-.4 1-1 1H7v-2h7c.6 0 1 .4 1 1z" />
  </Icon>
);

export const IconModuleHours = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M20 4C11.2 4 4 11.2 4 20s7.2 16 16 16 16-7.2 16-16S28.8 4 20 4zm1 29.9V31c0-.6-.4-1-1-1s-1 .4-1 1v2.9c-6.9-.5-12.5-6-12.9-12.9H9c.6 0 1-.4 1-1s-.4-1-1-1H6.1c.5-6.9 6-12.5 12.9-12.9V9c0 .6.4 1 1 1s1-.4 1-1V6.1c6.9.5 12.5 6 12.9 12.9H31c-.6 0-1 .4-1 1s.4 1 1 1h2.9c-.4 6.9-6 12.5-12.9 12.9zM20.6 19H26v2h-6.6l-5.8-9.3 1.7-1.1 5.3 8.4z" />
  </Icon>
);

export const IconModuleIframe = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M32 4H8C5.8 4 4 5.8 4 8v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4zm2 28c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V11h28v21zM6 9V8c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2v1H6zm3.2 13.6c-.3-.4-.3-.9 0-1.2l4-5c.3-.4 1-.5 1.4-.2.4.3.5 1 .2 1.4L11.3 22l3.5 4.4c.3.4.3 1.1-.2 1.4-.2.1-.4.2-.6.2-.3 0-.6-.1-.8-.4l-4-5zm16 3.8l3.5-4.4-3.5-4.4c-.3-.4-.3-1.1.2-1.4.4-.3 1.1-.3 1.4.2l4 5c.3.4.3.9 0 1.2l-4 5c-.2.3-.5.4-.8.4-.2 0-.4-.1-.6-.2-.5-.4-.5-1-.2-1.4zm-9.1 2.2l6-13c.2-.5.8-.7 1.3-.5s.7.8.5 1.3l-6 13c-.2.4-.5.6-.9.6-.1 0-.3 0-.4-.1-.5-.2-.7-.8-.5-1.3z" />
  </Icon>
);

export const IconModuleImage = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M33 5.5H7c-2.2 0-4 1.8-4 4v21c0 2.2 1.8 4 4 4h26c2.2 0 4-1.8 4-4v-21c0-2.2-1.8-4-4-4zm2 25c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-21c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2v21zm-26-17c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm17.6 2.6c-.3-.6-.9-1-1.5-1.1-.6-.1-1.2 0-1.8.3l-13.7 9c-.9.6-1.3 1.7-1 2.8.3 1.1 1.2 1.9 2.3 1.9h19.2c.9 0 1.7-.5 2.1-1.4.4-.8.3-1.8-.1-2.5l-5.5-9zm3.8 10.7c-.1.1-.2.2-.3.2H10.9c-.2 0-.3-.1-.4-.3-.1-.2 0-.5.2-.6l13.7-9c.1 0 .2-.1.2 0 .1 0 .2.1.2.2l5.5 9c.2.1.2.3.1.5z" />
  </Icon>
);

export const IconModuleImageAndText = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M17 8.5H4c-2.2 0-4 1.8-4 4v15c0 2.2 1.8 4 4 4h13c2.2 0 4-1.8 4-4v-15c0-2.2-1.8-4-4-4zm2 19c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-15c0-1.1.9-2 2-2h13c1.1 0 2 .9 2 2v15zm-15-12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm10 2.9c-.2-.5-.6-.8-1.1-.9-.4-.1-.9 0-1.3.3L4.7 23c-.6.4-.8 1.2-.7 2 .2.8.9 1.4 1.6 1.4h9.6c.7 0 1.3-.4 1.5-1.1.2-.6.2-1.2-.1-1.7L14 18.4zm-8 6.3c0-.1 0-.1 0 0zm.2-.2l6.3-4.8 2.5 4.8H6.2zm33.8-12c0 .6-.4 1-1 1H24v-2h15c.6 0 1 .4 1 1zm-7 6h-9v-2h9c.6 0 1 .4 1 1s-.4 1-1 1zm4 4c0 .6-.4 1-1 1H24v-2h12c.6 0 1 .4 1 1zm-3 5c0 .6-.4 1-1 1h-9v-2h9c.6 0 1 .4 1 1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleLinkCloud = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M11 23.1l1.4 1.4-2 2c-1 1-2.2 1.5-3.6 1.5h-.1c-1.3 0-2.6-.5-3.5-1.4-.9-.9-1.5-2.2-1.4-3.6 0-1.3.6-2.6 1.5-3.6l2-2 1.4 1.4-2 2c-.6.6-.9 1.4-.9 2.2 0 .8.3 1.6.9 2.1.5.7 1.3.9 2.1.9s1.6-.3 2.2-.9l2-2zM12.4 12c-1.3 0-2.6.6-3.6 1.5l-2 2 1.4 1.4 2-2c.6-.6 1.4-.9 2.2-.9.8 0 1.6.3 2.1.9 1.2 1.2 1.1 3.1-.1 4.3l-2 2 1.4 1.4 2-2c2-2 2-5.2.1-7.2-.9-1-2.2-1.5-3.5-1.4zm1.6 5.1l-1.4-1.4-7.1 7.1 1.4 1.4 7.1-7.1zm15.8 7.5c-1.2 1.2-3.2 1.3-4.3.1-1.2-1.2-1.1-3.1.1-4.3l2-2-1.4-1.4-2 2c-2 2-2 5.2-.1 7.2 1 1 2.2 1.4 3.5 1.4 1.3 0 2.6-.5 3.7-1.5l2-2-1.4-1.4-2.1 1.9zm7-11.2c-1.9-2-5.2-1.9-7.2.1l-2 2 1.4 1.4 2-2c1.2-1.2 3.2-1.3 4.3-.1 1.2 1.2 1.1 3.1-.1 4.3l-2 2 1.4 1.4 2-2c2.1-1.9 2.1-5.2.2-7.1zm-2.2 3.5l-1.4-1.4-7.1 7.1 1.4 1.4 7.1-7.1z" />
  </Icon>
);

export const IconModuleLinkGallery = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M24 9H4c-2.2 0-4 1.8-4 4v14c0 2.2 1.8 4 4 4h20c2.2 0 4-1.8 4-4V13c0-2.2-1.8-4-4-4zm2 18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V13c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v14zm-9-6c0 .6-.4 1-1 1H5v-2h11c.6 0 1 .4 1 1zm-4 4c0 .6-.4 1-1 1H5v-2h7c.6 0 1 .4 1 1zM36 9h-2c-2.2 0-4 1.8-4 4v2c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-2c0-2.2-1.8-4-4-4zm2 6c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v2zm-2 6h-2c-2.2 0-4 1.8-4 4v2c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-2c0-2.2-1.8-4-4-4zm2 6c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v2z" />
  </Icon>
);

export const IconModuleLinkGrid = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M15 7.5H7c-2.2 0-4 1.8-4 4v8c0 2.2 1.8 4 4 4h8c2.2 0 4-1.8 4-4v-8c0-2.2-1.8-4-4-4zm2 12c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v8zm16-12h-8c-2.2 0-4 1.8-4 4v8c0 2.2 1.8 4 4 4h8c2.2 0 4-1.8 4-4v-8c0-2.2-1.8-4-4-4zm2 12c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v8zm-20 8c0 .6-.4 1-1 1H3v-2h11c.6 0 1 .4 1 1zm18 0c0 .6-.4 1-1 1H21v-2h11c.6 0 1 .4 1 1zm-4 4c0 .6-.4 1-1 1h-7v-2h7c.6 0 1 .4 1 1zm-18 0c0 .6-.4 1-1 1H3v-2h7c.6 0 1 .4 1 1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleMap = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M32.6 8c-.3-.2-.6-.2-.9-.1L24 10.4l-7.7-3.3c-.1-.1-.4-.1-.6-.1l-8 2.6c-.4.2-.7.5-.7 1v20.6c0 .3.2.6.4.8.3.2.6.2.9.1l7.6-2.5 7.7 3.3c.1.1.3.1.4.1h.3l8-2.6c.4-.1.7-.5.7-1V8.9c0-.4-.2-.7-.4-.9zM17 9.5l6 2.6v18.4l-6-2.6V9.5zm-8 1.8l6-1.9v18.5l-6 1.9V11.3zm22 17.4l-6 1.9V12.2l6-1.9v18.4z" />
  </Icon>
);

export const IconModuleParagraph = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M34 12H5v-2h29c.6 0 1 .4 1 1s-.4 1-1 1zm-9 5c0-.6-.4-1-1-1H5v2h19c.6 0 1-.4 1-1zm9 5H5v2h29c.6 0 1-.4 1-1s-.4-1-1-1zm-10 6H5v2h19c.6 0 1-.4 1-1s-.4-1-1-1z" />
  </Icon>
);

export const IconModuleProductGrid = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M32.2 18.8l-1.1-1.1c-.2-.2-.4-.3-.7-.3h-.5l-1.1-7.9c-.2-1.2-1.2-2.1-2.4-2.1H13.6c-1.2 0-2.2.9-2.4 2.1l-1.1 7.9h-.5c-.3 0-.5.1-.7.3l-1.1 1.1c-.5.5-.8 1.2-.8 1.8v6.9c0 .6.4 1 1 1v3c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-3h12v3c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-3c.6 0 1-.4 1-1v-6.9c0-.6-.3-1.3-.8-1.8zm-19-8.9c0-.2.2-.4.4-.4h12.8c.2 0 .4.2.4.4l1.1 7.6H12.1l1.1-7.6zM9 20.6c0-.1.1-.2.2-.3l.8-.8h20l.8.8c.1.1.2.2.2.3v5.9H9v-5.9zm3 9.9h-2v-2h2v2zm18 0h-2v-2h2v2zM14 24c0 .8-.7 1.5-1.5 1.5S11 24.8 11 24s.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm15 0c0 .8-.7 1.5-1.5 1.5S26 24.8 26 24s.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleSeparator = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M40 20c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1h38c.6 0 1 .4 1 1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleTable = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M17 11c0 .6-.4 1-1 1H5v-2h11c.6 0 1 .4 1 1zm18 0c0-.6-.4-1-1-1H23v2h11c.6 0 1-.4 1-1zm-22 4c0-.6-.4-1-1-1H5v2h7c.6 0 1-.4 1-1zm18 0c0-.6-.4-1-1-1h-7v2h7c.6 0 1-.4 1-1zm-15 9H5v2h11c.6 0 1-.4 1-1s-.4-1-1-1zm18 0H23v2h11c.6 0 1-.4 1-1s-.4-1-1-1zm-22 4H5v2h7c.6 0 1-.4 1-1s-.4-1-1-1zm18 0h-7v2h7c.6 0 1-.4 1-1s-.4-1-1-1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleUspList = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M18.7 6.8l1.4 1.4-8.7 8.7c-.2.2-.5.3-.7.3s-.5-.1-.7-.3l-4.7-4.7 1.4-1.4 4 4 8-8zm-8 24l-4-4-1.4 1.4 4.7 4.7c.2.2.5.3.7.3s.5-.1.7-.3l8.7-8.7-1.4-1.4-8 8zm24-19.6c0-.6-.4-1-1-1h-11v2h11c.6 0 1-.4 1-1zm-1 15h-11v2h11c.6 0 1-.4 1-1s-.4-1-1-1zm-3-11c0-.6-.4-1-1-1h-7v2h7c.6 0 1-.4 1-1zm-1 15h-7v2h7c.6 0 1-.4 1-1s-.4-1-1-1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
);

export const IconModuleHtml = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M17 20h11c.6 0 1 .4 1 1s-.4 1-1 1H17v-2zM37 9v22c0 2.2-1.8 4-4 4H7c-2.2 0-4-1.8-4-4V9c0-2.2 1.8-4 4-4h26c2.2 0 4 1.8 4 4zm-2 4H5v18c0 1.1.9 2 2 2h26c1.1 0 2-.9 2-2V13zm0-4c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v2h30V9zM24 24H13v2h11c.6 0 1-.4 1-1s-.4-1-1-1zm-3 5c0-.6-.4-1-1-1H9v2h11c.6 0 1-.4 1-1zm0-12c0-.6-.4-1-1-1H9v2h11c.6 0 1-.4 1-1z" />
  </Icon>
);

export const IconModuleVideo = (props: IIcon) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path d="M14.2 27.8 30 20l-15.8-7.8v15.6zm2-12.4 9.2 4.6-9.2 4.6v-9.2zM33 6H7c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h26c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4zm2 24c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2v20z" />
  </Icon>
);

export const IconCampaignCategories = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M2 1a1 1 0 011-1h10a1 1 0 010 2H3a1 1 0 01-1-1zm14 3.2l-1.9 9a1 1 0 01-1 .8H3a1 1 0 01-1-.8L0 4.2a1 1 0 01.2-.8A1 1 0 011 3h14a1 1 0 01.8.4 1 1 0 01.2.8zm-2.2.8H2.2l1.5 7h8.6z" />
  </Icon>
);

export const IconExternalLink = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M15 3H21V9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14L21 3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const IconAi = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M7.07627 11.8636L7.66133 10.5234C8.18207 9.3309 9.11927 8.38157 10.2883 7.86264L11.8988 7.14777C12.4108 6.9205 12.4108 6.17562 11.8988 5.94835L10.3386 5.2558C9.13947 4.72352 8.18547 3.73904 7.67367 2.5058L7.081 1.07766C6.86107 0.547681 6.12879 0.547682 5.90887 1.07766L5.31618 2.50578C4.80438 3.73904 3.85035 4.72352 2.65123 5.2558L1.09105 5.94835C0.579024 6.17562 0.579024 6.9205 1.09105 7.14777L2.70153 7.86264C3.87059 8.38157 4.80781 9.3309 5.3285 10.5234L5.9136 11.8636C6.13851 12.3786 6.85133 12.3786 7.07627 11.8636ZM12.9343 15.1264L13.0988 14.7493C13.3921 14.0769 13.9205 13.5415 14.5797 13.2486L15.0866 13.0234C15.3608 12.9016 15.3608 12.5031 15.0866 12.3813L14.6081 12.1686C13.9319 11.8682 13.3941 11.313 13.1057 10.6178L12.9368 10.2102C12.819 9.92624 12.4263 9.92624 12.3085 10.2102L12.1396 10.6178C11.8513 11.313 11.3135 11.8682 10.6373 12.1686L10.1587 12.3813C9.8846 12.5031 9.8846 12.9016 10.1587 13.0234L10.6657 13.2486C11.3249 13.5415 11.8532 14.0769 12.1465 14.7493L12.3111 15.1264C12.4315 15.4025 12.8138 15.4025 12.9343 15.1264Z"
      fill="currentColor"
    />
  </Icon>
);
